import { BusinessStatus } from 'enum/common';
import { useMemo } from 'react';

interface IBusinessHeaderProps {
  selectedBusiness: BusinessType;
}
const BusinessHeader: React.FC<IBusinessHeaderProps> = ({ selectedBusiness }) => {
  const businessStatus = useMemo(() => {
    const activeStatus = {
      text: 'Active',
      textColor: 'text-green',
      bgColor: 'bg-greenLight',
      dotColor: 'bg-green',
    };

    const inactiveStatus = {
      text: 'Not Active',
      textColor: 'text-failed',
      bgColor: 'bg-failedLight',
      dotColor: 'bg-failed',
    };

    const pendingStatus = {
      text: 'Pending',
      textColor: 'text-yellow',
      bgColor: 'bg-yellowLight',
      dotColor: 'bg-yellow',
    };

    // Handle case-insensitive comparison for robustness
    const status = selectedBusiness?.businessStatus?.toLowerCase();

    // Special case: "inactive" with no deactivatedAt means newly created (pending approval)
    // "inactive" with deactivatedAt means actually deactivated
    if (status === 'inactive' && !selectedBusiness?.deactivatedAt) {
      return pendingStatus;
    }

    switch (status) {
      case BusinessStatus.ACTIVATED.toLowerCase():
      case 'active':
        return activeStatus;
      case BusinessStatus.DE_ACTIVATED.toLowerCase():
      case BusinessStatus.IN_ACTIVE.toLowerCase():
      case BusinessStatus.PARTIALLY_DEACTIVATED.toLowerCase():
      case 'deactivated':
      case 'inactive':
      case 'not active':
        return inactiveStatus;
      case BusinessStatus.PENDING.toLowerCase():
      case 'pending':
        return pendingStatus;
      default:
        // For unknown status, default to pending
        return pendingStatus;
    }
  }, [selectedBusiness?.businessStatus, selectedBusiness?.deactivatedAt]);

  return (
    <div className="sticky top-0 md:top-0 z-[40] bg-white flex-shrink-0 mb-6 pb-6">
      <div className="flex items-center gap-3">
        <div className="text-darkBlue text-2xl font-medium">Welcome {selectedBusiness?.name}</div>
        <div
          className={`flex items-center font-medium text-sm min-w-[90px] h-[29px] gap-2 pt-1 pr-3 pb-1 pl-3 rounded-[54px] ${businessStatus.bgColor}`}
        >
          <span
            className={`rounded-full flex-shrink-0 w-[6px] h-[6px] ${businessStatus.dotColor}`}
          ></span>
          <span className={businessStatus.textColor}>{businessStatus.text}</span>
        </div>
      </div>
    </div>
  );
};

export default BusinessHeader;
